import React from "react";
import { Grid } from "@material-ui/core";
import View from "components/utils/View";
import { SrTable, SrContentWrapper, SrContentHeader } from "components/common";
import InvoiceForm from "./InvoiceForm";
import useBilling from "./useBilling";
import InvoicesActions from "./InvoicesActions";
import useInvoices from "./useInvoices";
import translate from "../../../../i18n/translate";

const Invoices = () => {
  const {
    invoicesColumns,
    invoicesRows,
    loading: invoicesLoading,
    getInvoices,
  } = useInvoices();
  const {
    automaticBilling,
    fiscalRegimeOptions,
    error,
    setError,
    initialValues,
    loading,
    loadingTowns,
    onBillingClick,
    onSelectTown,
    onSubmit,
    onZipCodeChange,
    setShowBilling,
    showBilling,
    showManualBilling,
    towns,
    validationSchema,
  } = useBilling(getInvoices);

  return (
    <View translateTitleKey="menu.invoices">
      {showBilling ? (
        <InvoiceForm
          initialValues={initialValues}
          isAutomaticBilling={automaticBilling}
          fiscalRegimeOptions={fiscalRegimeOptions}
          isLoadingTowns={loadingTowns}
          isSubmitting={loading}
          onReturn={() => {
            setShowBilling(false);
            setError(false);
          }}
          onSelectTown={onSelectTown}
          onSubmit={(form) => onSubmit(form, automaticBilling)}
          onZipCodeChange={onZipCodeChange}
          towns={towns}
          validationSchema={validationSchema}
          error={error}
        />
      ) : (
        <Grid container justifyContent="space-between">
          <SrContentHeader title={translate("invoices.heading")} />
          {!loading && (
            <InvoicesActions
              showManualBilling={showManualBilling}
              onBillingClick={onBillingClick}
            />
          )}
          <SrContentWrapper
            isLoading={invoicesLoading || loading}
            isEmpty={!invoicesRows?.length}
            emptyMessage={translate("invoices.noAddedInvoice")}
            smallPaddingY
          >
            <SrTable columns={invoicesColumns} rows={invoicesRows} />
          </SrContentWrapper>
        </Grid>
      )}
    </View>
  );
};

export default Invoices;
